export interface HSL {
  h: number;
  s: number;
  l: number;
}
